// t() has no plural forms, so the key is chosen by the count: English and
// Dutch both use one form for 1 and another for every other number
// ("1 day" / "0 days", "1 dag" / "2 dagen"). Both keys carry {count}.
export const tn = (t, count, one, other, vars = {}) => t(Number(count) === 1 ? one : other, { count, ...vars });

export default tn;
